import { useEffect, useState } from "react";

export type LoadImage = (att: string, mime: string) => Promise<string | null>;

/** One lazily-loaded, decrypted image (used for single attachments + gallery tiles). Click to open full-size. */
export function LazyImage({
  att,
  mime,
  load,
  className,
  onOpen,
}: {
  att: string;
  mime: string;
  load: LoadImage;
  className: string;
  onOpen?: (url: string) => void;
}) {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    let ok = true;
    void load(att, mime).then((u) => ok && setUrl(u));
    return () => {
      ok = false;
    };
  }, [att, mime, load]);
  return url ? (
    <img className={className} src={url} alt="" style={{ cursor: "zoom-in" }} onClick={() => onOpen?.(url)} />
  ) : (
    <span className="muted">Loading image…</span>
  );
}
